module.exports = __webpack_public_path__ + "static/media/tiktok.7aca5e48.svg";